import React from 'react';
import { Modal, Nav, Tab } from "react-bootstrap";
import ErrorMessage from './ErrorMessage';
import { diffCheck, formatDate, formatStatus, ucFirst } from "../../../../../../util/Helpers";
import { SubscriptionIcon } from '../../../../../../util/Icons';
import SimpleTable from "my-simple-react-table"


const UpdateSubscription = ({ show, action: { action, error, data }, onHide }) => {
    const { meta: oldData, ...newData } = data

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <SubscriptionIcon />
                    </span> {action}
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Tab.Container defaultActiveKey={""}>
                <Nav
                    className="d-flex w-100 px-4 border-bottom align-items-center bg-white position-sticky top-0"
                    style={{
                        height: "46px",
                        zIndex: 1
                    }}
                >
                    <Nav.Item>
                        <Nav.Link className="px-3" eventKey={""}>
                            <div>Details</div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link className="px-3" eventKey={"activities"}>
                            <div>Activities</div>
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
                <Modal.Body>
                    <ErrorMessage {...{ error }} />
                    <Tab.Content className={"h-100 mx-7 mb-7"}>
                        <Tab.Pane eventKey={""} className={"h-100"}>
                            <div className="row">
                                <div className="col-lg py-4">
                                    <h6>Product</h6>
                                    <span className="text-muted">{diffCheck(oldData?.product, newData?.product)}</span>
                                </div>
                                <div className="col-lg py-4">
                                    <h6>Sub Key</h6>
                                    <span className="text-muted">{diffCheck(oldData?.subKey, newData?.subKey)}</span>
                                </div>
                                <div className="col-lg py-4">
                                    <h6>Status</h6>
                                    {formatStatus(oldData?.status)}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg py-4">
                                    <h6>User ID</h6>
                                    <span className="text-muted">{oldData?.userId}</span>
                                </div>
                                <div className="col-lg py-4">
                                    <h6>Account ID</h6>
                                    <span className="text-muted">{oldData?.accountId}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg py-4">
                                    <h6>Due Date</h6>
                                    <span className="text-muted">{formatDate(oldData?.dueDate)}</span>
                                </div>
                                <div className="col-lg py-4">
                                    <h6>Created At</h6>
                                    <span className="text-muted">{formatDate(oldData?.created)}</span>
                                </div>
                                <div className="col-lg py-4">
                                    <h6>Updated At</h6>
                                    <span className="text-muted">{formatDate(oldData?.updated)}</span>
                                </div>
                            </div>
                            <div className="row">
                                {
                                    Object.keys(oldData?.model || {}).map((key) => (
                                        <div key={key} className="col-3 py-4">
                                            <h6>{ucFirst(key)}</h6>
                                            <span className="text-muted">{diffCheck(oldData?.model[key]?.toString(), newData?.model?.[key]?.toString())}</span>
                                        </div>
                                    ))
                                }
                            </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey={"activities"} className={"h-100"}>
                            <SimpleTable
                                data={oldData?.activity || []}
                                columns={[
                                    { title: "ACTIVITY", key: "activity" },
                                    { title: "DATE", format: row => formatDate(row.date) },
                                    { title: "STATUS", format: row => formatStatus(row.status) },
                                ]}
                                searchBox={false}
                            />
                        </Tab.Pane>
                    </Tab.Content>
                </Modal.Body>
            </Tab.Container>
            <Modal.Footer className="justify-content-center">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-primary btn-elevate px-5"
                >
                    Okay
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default UpdateSubscription;